import {DefaultSettings} from '../../../../settings/settings-util';
import {Reducer, Store} from "redux";
import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import MarkdownUtility from "../utils/markdown-utility";
import {Message} from "../../../../types/response";
import {AlmeResponseV5} from "@alme/types/response/AlmeResponse";
import {enableInputBox, disableInputBox} from '../../../lib-inputbox-toggle/lib/lib-inputbox-toggle';


export default class MarkdownResponseHandler
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _markdownUtil: MarkdownUtility;


    //#region Public Interface

    constructor(settings: DefaultSettings, markdownUtility: MarkdownUtility)
    {
        this._settings = settings;
        this._markdownUtil = markdownUtility;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;

        this._markdownUtil.initialize(this._store);
    }

    getReducer(): Reducer<AlmeState>
    {
        return (state: AlmeState = defaultState): AlmeState => state;
    }

    doesHandle(message: Message): boolean
    {
        if (!message.messageType) { return false; }

        const mc = this._settings.messageConstants;
        return [
            mc.converseRequest,
            mc.requestUnitRequest,
            mc.appeventRequest,
            mc.getHistoryRequest,
            mc.errorResponseType,
        ].includes(message.messageType);
    }

    process(message: Message): Message
    {
        if (!this.doesHandle(message)) { return message; }

       return this.processMessage(message);
    }

    //#endregion



    //#region Helper Methods

    processMessage(message: Message): Message
    {
        message.response = Array.isArray(message.response) ?
            message.response.map(response => this.processResponse(response, message)) :
            this.processResponse(message.response as AlmeResponseV5, message);

        return message;
    }

    processResponse(response: AlmeResponseV5, message: Message): AlmeResponseV5
    {
        if(response.responseActions?.find(x => x.Name =="LiveChatStart"))
        {
            disableInputBox(this._store, this._settings, () => true);
        }
        if (message.error)
        {
            if (!message.errorText) { return response; }
            return this._markdownUtil.convertResponse(response, message.errorText);
        }
        if (!response.text) { return response; }

        return this._markdownUtil.convertResponse(response, response.text);
    }



    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/response-handler-markdown/src/handlers/response-handler.ts